import template from './setup.create.html';
import controller from './setup.create.controller';
import './setup.create.scss';

let setupcreateComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default setupcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/create/setup.create.component.js